import React from 'react';
import '../../pages/vault/vault.css';
import '../../styles/shopper.css';

interface ShopperLoadingProps {
  theme?: 'light' | 'dark';
  label?: string;
  testId?: string;
}

// Loading on the shopper pages (#467): a stitched spool turning on the mat,
// in place of the old cyan spinner.
const ShopperLoading: React.FC<ShopperLoadingProps> = ({ theme = 'dark', label = 'Opening the label…', testId }) => (
  <div className="vault vault-page grid place-items-center" data-vault-theme={theme}>
    <div className="grid justify-items-center gap-3.5 text-[14px] text-[var(--v-text-2)]" role="status" data-testid={testId}>
      <svg className="sh-spool" viewBox="0 0 64 64" width="64" height="64" aria-hidden="true">
        <circle cx="32" cy="32" r="24" />
      </svg>
      <span>{label}</span>
    </div>
  </div>
);

export default ShopperLoading;
